import SiteState from '../interfaces/SiteState';
import siteResponseToSiteObjConverter from './responseToSiteObjConverter';
import testSites from '../testData/testSites';
import SiteType from '../interfaces/SiteType';

//#region INITIAL_STATE
export const initialState: SiteState = {
  isSiteStateReady: false,
  sites: [],
  nonValidSites: [],
  errors: [],
  isTestSitesEnabled: false,
  allSiteTypes: new Set(),
};
//#endregion INITIAL_STATE

//#region ACTIONS
export const actionTypes = {
  UPDATE_SITES: 'UPDATE_SITES',
  ENABLE_TEST_SITES: 'ENABLE_TEST_SITES',
  DISABLE_TEST_SITES: 'DISABLE_TEST_SITES',
} as const;

type ActionType = typeof actionTypes;

type Action =
  | {type: ActionType['UPDATE_SITES']; payload: any}
  | {type: ActionType['ENABLE_TEST_SITES']}
  | {type: ActionType['DISABLE_TEST_SITES']};

//#endregion ACTIONS

export const reducer = (state: SiteState, action: Action): SiteState => {
  switch (action.type) {
    case 'UPDATE_SITES': {
      const {validSites, nonValidSites, errors, allSiteTypes} = siteResponseToSiteObjConverter(
        action.payload
      );
      return {
        ...state,
        allSiteTypes,
        sites: [...state.sites, ...validSites],
        nonValidSites: nonValidSites,
        isSiteStateReady: true,
        errors: [...state.errors, ...errors],
      };
    }
    case 'ENABLE_TEST_SITES': {
      const {
        allSiteTypes,
        validSites: testValidSites,
        nonValidSites: testNonValidSites,
        errors: testErrors,
      } = siteResponseToSiteObjConverter(testSites);

      const newSiteTypeSet = new Set<SiteType>();
      state.allSiteTypes.forEach(siteType => {
        newSiteTypeSet.add(siteType);
      });
      allSiteTypes.forEach(siteType => {
        newSiteTypeSet.add(siteType);
      });
      return {
        ...state,
        allSiteTypes: newSiteTypeSet,
        sites: [...state.sites, ...testValidSites],
        nonValidSites: [...state.nonValidSites, ...testNonValidSites],
        errors: [...state.errors, ...testErrors, 'Test sites enabled'],
        isTestSitesEnabled: true,
      };
    }
    case 'DISABLE_TEST_SITES':
      //re-fetches from API
      return initialState;
    default:
      return state;
  }
};
